import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import { getOptionValue } from "common/enums";
import { giftInfo } from "Routes/constants";

import { getImageUrl } from "utils";
import { useMediaQuery } from "@mui/material";

const HeaderChild = ({
  child = [],
  headerName = "",
  isDropDown = false,
  isGiftInfo,
}) => {
  const sm = useMediaQuery("(max-width: 767px)");

  const navigate = useNavigate();

  const dropDownClickHandler = (id, contentType, content) => {
    if (contentType === getOptionValue("homeContentType", "Text")) {
      navigate(giftInfo, { state: { id } });
    }
    if (contentType === getOptionValue("homeContentType", "Document")) {
      window.open(getImageUrl(content), "_blank");
    }
  };

  return (
    <>
      <UncontrolledDropdown nav inNavbar direction="down">
        <DropdownToggle
          nav
          caret
          className={
            isDropDown
              ? ""
              : `navbar-options ${
                  !isGiftInfo && !sm ? "navbar-menu-items" : ""
                }`
          }
          style={isDropDown && !isGiftInfo && !sm ? { color: "#fff" } : {}}
        >
          {headerName}
        </DropdownToggle>

        <DropdownMenu
          updateOnSelect={false}
          positionFixed={true}
          className={!isGiftInfo && !sm ? "navbar-menu-items" : ""}
          style={
            !isGiftInfo && !sm
              ? {
                  background: "rgb(26 24 24)",
                }
              : {}
          }
        >
          {child.map(({ name, contentType, content, child, id }, index) => (
            <DropdownItem
              toggle={!child.length}
              key={index}
              onClick={() => dropDownClickHandler(id, contentType, content)}
              className={!isGiftInfo && !sm ? "navbar-menu-items" : ""}
              style={{
                color: !isGiftInfo && !sm ? "#fff" : "black",
                ...(sm
                  ? {
                      textWrap: "wrap",
                    }
                  : {
                      width: "20rem",
                      textWrap: "wrap",
                    }),
              }}
            >
              {child.length ? (
                <HeaderChild
                  child={child}
                  headerName={name}
                  isDropDown
                  isGiftInfo={isGiftInfo}
                />
              ) : (
                name
              )}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

HeaderChild.propTypes = {
  child: PropTypes.array,
  headerName: PropTypes.string,
  isDropDown: PropTypes.bool,
  isGiftInfo: PropTypes.bool,
};

export default HeaderChild;
